import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InventoryStoreService {
    private readonly _refreshSignal = new BehaviorSubject<number>(Date.now());

    readonly refresh$ = this._refreshSignal.asObservable();

    requestRefresh(): void {
        this._refreshSignal.next(Date.now());
    }
}
